<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Visão Geral
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :loading="carregando"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        disable-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
      <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters align="center">
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para PDF</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.usi_nome="{ item }">
          {{item.usi_nome}}
          <v-chip v-if="item.usi_desativada" class="ml-2" small color="primary">Desativada</v-chip>
        </template>
        <template v-slot:item.clima="{ item }">
          <v-tooltip top v-if="item.usi_clima_icone">
            <template v-slot:activator="{ on, attrs }">
              <img v-bind="attrs" v-on="on" class="imagem_usina_clima" :src="`http://openweathermap.org/img/wn/${item.usi_clima_icone}@2x.png`" />
            </template>
            <span v-if="item.usi_clima_descricao" class="text-capitalize">{{item.usi_clima_descricao}}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="goToInterna(item)" color="primary">
                visibility
              </v-icon>
            </template>
            <span>Detalhes</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="1200px"
      >
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Detalhes da usina
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="dialog = false">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <div class="ui-dialog-content" :class="$vuetify.theme.dark ? 'bg-black' : 'bg-white'">
          <v-row>
            <v-col cols="12" sm="12" md="3" lg="3" xl="3">
              <v-card class="mb-3 px-2 py-3" elevation="2">
                <div class="imagem_usina mb-3" :style="`background-image: url('${require('@/assets/img/usina.jpg')}')`"></div>
                <div class="text text-h3 mb-2">Nome da usina</div>
                <div class="text mb-2">PV Capacidade: 33.00KW</div>
                <div class="text">27/07/2022</div>
              </v-card>
              <v-card class="mb-3 px-2 py-3" elevation="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="primary">
                      sunny
                    </v-icon>
                  </template>
                  <span>Clima ensolarado</span>
                </v-tooltip>
                <div class="text mb-1 mt-1">
                  Horário do sol: 06:58 - 18:05
                </div>
                <div class="text">
                  Temperatura: 10ºC ~ 23ºC
                </div>
              </v-card>
              <v-card elevation="2" class="px-2 py-3 text-center">
                <div class="text-h2 text-primary mb-3">
                  Status
                </div>
                <div class="text-h3 text-green">
                  <b>
                    Normal
                  </b>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="9" lg="9" xl="9">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-card class="blocos px-2 py-3 geracao bg-primary" elevation="2">
                    <v-row justify="space-between" align="center">
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="text-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" x-large :color="$vuetify.theme.dark ? 'white' : 'black'">
                              electric_bolt
                            </v-icon>
                          </template>
                          <span>Geração de energia</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="12" md="9" lg="9" xl="9">
                        <div class="mb-2">
                          <span class="text-h1">
                            20987.90
                          </span>
                          <span class="text">
                            kWh Total
                          </span>
                        </div>
                        <div class="mb-2">
                          <span class="text">
                            149.80 kWh dia / 13756.30 kWh ano
                          </span>
                        </div>
                        <div>
                          <span class="text">
                            17.53 kW potência de saída
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-card class="blocos px-2 py-3 dinheiro bg-blue" elevation="2">
                    <v-row justify="space-between" align="center">
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="text-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" x-large :color="$vuetify.theme.dark ? 'white' : 'black'">
                              payments
                            </v-icon>
                          </template>
                          <span>Renda</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="12" md="9" lg="9" xl="9">
                        <div class="mb-2">
                          <span class="text-h1">
                            R$ 100.678,95
                          </span>
                          <span class="text">
                            Total
                          </span>
                        </div>
                        <div class="mb-2">
                          <span class="text">
                            R$ 200,15 Dia
                          </span>
                        </div>
                        <div>
                          <span class="text">
                            R$ 999.999,00 Ano
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <v-card class="blocos px-2 py-3 status bg-green" elevation="2">
                    <v-row no-gutters justify="space-between">
                      <div>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" x-large color="white">
                              router
                            </v-icon>
                          </template>
                          <span>Status</span>
                        </v-tooltip>
                      </div>
                      <div>
                        <div class="text">
                          <b>
                            Normal
                          </b>
                        </div>
                      </div>
                    </v-row>
                  </v-card>
                </v-col> -->
              </v-row>
              <v-row no-gutters class="mt-3 mb-3">
                <div class="mw-100">
                  <v-autocomplete
                    autocomplete="off"
                    :items="['Dia', 'Mês', 'Ano']"
                    append-icon="expand_more"
                    outlined
                    v-model="dataFiltro"
                    hide-details=""
                  ></v-autocomplete>
                </div>
                <div class="ml-3">
                  <VueCtkDateTimePicker
                    v-on:callback="changeDates"
                    v-model="data_entrada"
                    class="date-picker py-1"
                    locale="pt-BR"
                    :no-header="true"
                    :no-value-to-custom-elem="true"
                    :overlay="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    color="#EC6521"
                    :dark="$vuetify.theme.dark"
                    button-color="#EC6521"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :noClearButton="true"
                    :auto-close="true"
                    :loading="loadingSearch"
                    :disabled="loadingSearch"
                    :submit="retornoData()"
                  >
                    <v-btn class="px-2 py-1 pt-2 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                      <b class="text text-primary">
                        Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                      </b>
                    </v-btn>
                  </VueCtkDateTimePicker>
                </div>
              </v-row>
              <line-chart :options="optionsChart" :height="150" :data="chartData"></line-chart>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-card elevation="2" class="px-2 py-2">
                <div class="text-h3 text-primary mb-3">
                  Usina Luciano
                </div>
                <v-row justify="space-between" align="end">
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <div class="text">
                      <v-icon>person</v-icon> BRNET
                    </div>
                    <div class="text mt-4">
                      <v-icon>build</v-icon> ToolData
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <div class="text">
                      <v-icon class="mb-1">battery_charging_full</v-icon> 00.00 MWh
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-card elevation="2" class="px-2 py-3 text-center">
                <div class="text-h3 text-primary mb-3">
                  Status
                </div>
                <div class="text text-green">
                  <b>
                    Normal
                  </b>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-card elevation="2" class="px-2 py-3 text-center">
                <div class="text-h3 text-primary mb-3">
                  Total Gerado
                </div>
                <div class="text">
                  6522 mWh
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-card elevation="2" class="px-2 py-3 text-center">
                <div class="text-h3 text-primary mb-3">
                  Potência instantânea
                </div>
                <div class="text">
                  61 KW
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-card elevation="2" class="px-2 py-3 text-center">
                <div class="text-h3 text-primary mb-3">
                  Geração de hoje
                </div>
                <div class="text">
                  1556 kWp
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-card elevation="2" class="px-2 py-3 text-center">
                <div class="text-h3 text-primary mb-3">
                  Potência instalada
                </div>
                <div class="text">
                  100 kWp
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-card elevation="2" class="px-2 py-3 text-center">
                <div class="text-h3 text-primary mb-3">
                  Geração últimos 30 dias
                </div>
                <div class="text">
                  6522 kWp
                </div>
              </v-card>
            </v-col>
          </v-row> -->
          <v-divider class="mt-4"></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              @click="dialog = false"
            >
              Fechar
            </v-btn>
          </v-row>
        </div>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import LineChart from '@components/graficos/LineChart.vue'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'
export default {
  components: {
    LineChart,
    VueCtkDateTimePicker
  },
  data () {
    return {
      nivelUsuarioApelido: '',
      carregando: false,
      loading: true,
      search: '',
      searchFinal: '',
      integrador: null,
      integradores: [],
      distribuidor: null,
      distribuidorAnterior: null,
      distribuidores: [],
      loadingSearch: false,
      loadingIntegradores: false,
      loadingDistribuidores: false,
      total: 0,
      options: {},
      dialog: false,
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      dataFiltro: 'Dia',
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'usi_id'
        },
        { text: 'Cliente', value: 'cliente.cli_nome' },
        { text: 'Usina', value: 'usi_nome' },
        { text: 'Cidade', value: 'usi_cidade' },
        { text: 'Status', value: 'status.uss_nome' },
        {
          text: 'Clima',
          value: 'clima',
          align: 'center',
          sortable: false
        },
        { text: 'Hoje', value: 'producao.hoje' },
        { text: 'Ontem', value: 'producao.ontem' },
        { text: 'Últimos 7 dias', value: 'producao.semana' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      dadosImpressao: [],
      optionsChart: {
        tooltips: {
          mode: 'index',
          intersect: false
        },
        responsive: true,
        legend: { display: false },
        scales: {
          // xAxes: [
          //   {gridLines: { color: '#fff', zeroLineColor: '#fff' }}
          // ],
          // yAxes: [
          //   {
          //     gridLines: { color: '#fff', zeroLineColor: '#ffcc33' },
          //     ticks: {
          //       beginAtZero: true
          //     }
          //   }
          // ]
        },
        plugins: {
          legend: {
            position: 'top'
          }
        }
      },
      chartData: {
        labels: ['03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'],
        datasets: [
          {
            label: 'Potência (W)',
            backgroundColor: '#EC6521',
            data: [40, 39, 10, 40, 39, 80, 40, 350, 33, 100, 123, 312, 312, 312, 3, 2]
          }
        ]
      }
    }
  },
  watch: {
    options: {
      handler () {
        this.getUsinas()
      },
      deep: true
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios', {
        headers: this.someHeader(),
        distribuidor: this.distribuidor,
        integrador: this.integrador,
        busca: this.searchFinal,
        type: 'visao-geral'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf () {
      this.$root.Printer.openDialog(this, {
        titulo: 'Visão geral', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: this.dados,
        headers: this.someHeader(), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Clima') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.getDistribuidores()
      this.getIntegradores()
      this.getUsinas()
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true

      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt

          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUsinas () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      let endpoint = ''

      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      if (this.distribuidor) {
        endpoint += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        endpoint += '&integrador=' + this.integrador
      }
      if (this.searchFinal) {
        endpoint += `&busca=${this.searchFinal}`
      }

      await Api.get(`usinas/visao-geral?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          this.dados = res.data.data
          this.total = res.data.total
          this.carregando = false
          this.loading = false
        })
        .catch(err => {
          this.carregando = false
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openDialog () {
      this.dialog = true
    },
    goToInterna (item) {
      this.$router.push({ name: 'VisaoGeralInterna', params: { uuid: item.uuid_usi_id } }).catch(() => {})
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'VisaoGeral', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getUsinas()
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.imagem_usina {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 200px;
  width: 100%;
}
.imagem_usina_clima {
  width: 40px;
}
.mw-100 {
  max-width: 100px;
}
.blocos {
  min-height: 130px;
}
.date-picker {
  .search_data {
    margin-top: -4px;
    min-height: 40px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/visaoGeral/VisaoGeral.vue